import React, { Component } from 'react';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";

import SlideItems from "../../../shared/EventSlideItems";
import ModalEvents from "./ModalEvents";

class Pensum extends Component {
    state = {
        responsive: {
            0: { items: 1 },
            1024: { items: 3 }
        },
        currentIndex: 0,
        openW: false,
        currentImg: "",
    }

    showModal = () => {
        const { openW, currentImg } = this.state;
        return (
            <ModalEvents
                isopen =  { openW }
                contenido = { currentImg }
                cerrar = {this.cerrarModal}
            />
        );
    }

    openModal = (img) => (e) => {
        this.setState ({
            openW: true,
            currentImg: img
        })
    }

    cerrarModal = () => {
        this.setState ({
            openW: false,
        })
    }

    onSlideChanged = (e) => {
        this.setState({currentIndex: e.item})
    }

    imagenes = () => {
        const handleOnDragStart = e => e.preventDefault()
        return (
            SlideItems.map(option => (
                <img
                    src={option.img}
                    key ={option.id}
                    onClick = {this.openModal(option.img)}
                    onDragStart={handleOnDragStart}
                    className="img img-responsive"
                    style={{padding:5, cursor:"pointer"}}
                    title= "Haz click en la imagen para agrandarla"
                />
            ))
        )
    }

    render() {
        let  { responsive, currentIndex } = this.state;

        return (
            <div style={{paddingTop:40, paddingBottom:20}}>
                <AliceCarousel
                    items={this.imagenes()}
                    autoPlayInterval={4000}
                    autoPlayDirection="ltr"
                    autoPlay={true}
                    fadeOutAnimation={true}
                    mouseDragEnabled={true}
                    responsive={responsive}
                    buttonsDisabled={true}
                    startIndex={currentIndex}
                    onSlideChanged={this.onSlideChanged}
                />
                {this.showModal()}
            </div>
        );
    }
}
 
export default Pensum;


// WEBPACK FOOTER //
// ./src/site/Componentes/Eventos/Content.jsx